import { createAction } from 'typesafe-actions';

export const genericError = createAction('errors/GENERIC_ERROR')<string>();
